import { supabase } from "./core.js";
import type { ClientMeta } from "../types/index.js";

export async function fetchClientMeta(clientId: string): Promise<ClientMeta | null> {
  const { data, error } = await supabase
    .from("clients_meta")
    .select("*")
    .eq("client_id", clientId)
    .single();
  if (error) {
    if (error.code === "PGRST116") return null;
    throw error;
  }
  return data;
}

export async function fetchAllClientsMeta(): Promise<ClientMeta[]> {
  const { data, error } = await supabase.from("clients_meta").select("*").order("client_id");
  if (error) throw error;
  return data || [];
}

export async function upsertClientMeta(
  clientId: string,
  payload: Partial<ClientMeta>
): Promise<void> {
  const { error } = await supabase
    .from("clients_meta")
    .upsert({ ...payload, client_id: clientId }, { onConflict: "client_id" });
  if (error) throw error;
}

interface SimulacaoAposent {
  id?: string;
  client_id: string;
  form_data?: Record<string, unknown>;
  cenario?: Record<string, unknown>;
  [key: string]: unknown;
}

export async function fetchSimulacaoAposent(clientId: string): Promise<SimulacaoAposent | null> {
  const { data, error } = await supabase
    .from("simulacao_aposentadoria")
    .select("*")
    .eq("client_id", clientId)
    .single();
  if (error) {
    if (error.code === "PGRST116") return null;
    throw error;
  }
  return data;
}

export async function upsertSimulacaoAposent(
  clientId: string,
  form: Record<string, unknown>,
  cenario: Record<string, unknown>
): Promise<void> {
  const { error } = await supabase
    .from("simulacao_aposentadoria")
    .upsert(
      { client_id: clientId, form_data: form, cenario, updated_at: new Date().toISOString() },
      { onConflict: "client_id" }
    );
  if (error) throw error;
}

interface MetaFinanceira {
  id?: string;
  client_id: string;
  [key: string]: unknown;
}

export async function fetchMetas(clientId: string): Promise<MetaFinanceira[]> {
  const { data, error } = await supabase
    .from("metas_financeiras")
    .select("*")
    .eq("client_id", clientId)
    .order("created_at", { ascending: false });
  if (error) throw error;
  return data || [];
}

export async function upsertMetas(
  clientId: string,
  metas: Partial<MetaFinanceira>[]
): Promise<void> {
  const rows = metas.map((m) => ({ ...m, client_id: clientId }));
  const { error } = await supabase.from("metas_financeiras").upsert(rows, { onConflict: "id" });
  if (error) throw error;
}

interface TargetAllocation {
  client_id: string;
  allocation: Record<string, number>;
  [key: string]: unknown;
}

export async function fetchTargetAllocation(clientId: string): Promise<TargetAllocation | null> {
  const { data, error } = await supabase
    .from("target_allocation")
    .select("*")
    .eq("client_id", clientId)
    .single();
  if (error) {
    if (error.code === "PGRST116") return null;
    throw error;
  }
  return data;
}

export async function upsertTargetAllocation(
  clientId: string,
  allocation: Record<string, number>
): Promise<void> {
  const { error } = await supabase
    .from("target_allocation")
    .upsert(
      { client_id: clientId, allocation, updated_at: new Date().toISOString() },
      { onConflict: "client_id" }
    );
  if (error) throw error;
}
